/* @flow */
import Collection from 'lib/Collection';
import MessageRecipient from 'entities/MessageRecipient';

class MessageRecipients extends Collection {
  initialize() {
    this.model = MessageRecipient;
  }

  comparator(a: MessageRecipient, b: MessageRecipient) {
    if (a.isGroup() && b.isSubscriber()) {
      return -1;
    }
    if (a.isSubscriber() && b.isGroup()) {
      return 1;
    }

    if (!a.isDeleted() && b.isDeleted()) {
      return -1;
    }
    if (a.isDeleted() && !b.isDeleted()) {
      return 1;
    }

    return a.getName().localeCompare(b.getName());
  }

  getCounts() {
    return {
      group: this.getGroupCount(),
      subscriber: this.getSubscriberCount(),
    };
  }

  getGroupCount() {
    // This where() is provided by backbone-collection, NOT proxied to lodash
    // which is nice because where() has been removed in lodash 4
    return this.where({ type: 'group' }).length;
  }

  getSubscriberCount() {
    return this.where({ type: 'subscriber' }).length;
  }
}

export default MessageRecipients;



// WEBPACK FOOTER //
// ./src/collections/MessageRecipients.js